import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, LITURGY_LABEL } from "@/lib/api";

const DayPage = () => {
    const { date } = useParams();
    const [day, setDay] = useState(null);
    useEffect(() => { api.get(`/liturgical/day`, { params: { date } }).then(r => setDay(r.data)); }, [date]);
    if (!day) return <div className="max-w-3xl mx-auto py-24 text-center text-muted-foreground">Loading…</div>;
    const formatted = new Date(day.date + "T00:00:00").toLocaleDateString(undefined, { weekday: "long", month: "long", day: "numeric", year: "numeric" });
    return (
        <div className="max-w-3xl mx-auto px-6 py-16" data-testid="day-page">
            <Link to="/calendar" className="small-caps text-xs accent-liturgy hover:underline">← Back to calendar</Link>
            <div className="mt-8 text-center">
                <div className="small-caps text-xs text-muted-foreground">{formatted}</div>
                <h1 className="font-serif text-4xl md:text-5xl mt-4">{day.feast || day.season}</h1>
                <div className="mt-3 small-caps text-xs accent-liturgy">{LITURGY_LABEL[day.color]} · {day.rank}</div>
            </div>
            <div className="mt-12 missal-card p-8 md:p-10 space-y-6">
                <div>
                    <div className="small-caps text-[11px] accent-liturgy mb-2">First Reading — {day.readings.first_reading.citation}</div>
                    <p className="leading-relaxed text-[15px]">{day.readings.first_reading.text}</p>
                </div>
                <div>
                    <div className="small-caps text-[11px] accent-liturgy mb-2">Responsorial Psalm — {day.readings.responsorial_psalm.citation}</div>
                    <p className="italic leading-relaxed text-[15px]">{day.readings.responsorial_psalm.text}</p>
                </div>
                <div>
                    <div className="small-caps text-[11px] accent-liturgy mb-2">Gospel — {day.readings.gospel.citation}</div>
                    <p className="leading-relaxed text-[15px]">{day.readings.gospel.text}</p>
                </div>
                <blockquote className="border-l-2 border-liturgy pl-6 py-2 italic text-lg leading-relaxed">{day.readings.reflection}</blockquote>
            </div>
        </div>
    );
};

export default DayPage;
